import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'green' | 'amber' | 'red';

/** Nhãn nhỏ (mã dự án, trạng thái) hoặc số đếm (`count`: viên tròn nền nhấn). */
export function Badge({
  children,
  tone = 'accent',
  count = false,
  title,
  testId,
}: {
  children: ReactNode;
  tone?: BadgeTone;
  count?: boolean;
  title?: string;
  testId?: string;
}) {
  return (
    <span className={`ws-badge ws-badge-${tone}${count ? ' ws-badge-count' : ''}`} title={title} data-testid={testId}>
      {children}
    </span>
  );
}
